import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton, ButtonProps } from '@material-ui/core';

const Button = styled(MuiButton)`
  &.MuiButton-root {
    text-transform: inherit;
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--orange);
    min-width: 88px;
    height: 32px;
    background: var(--white);
    border: 1px solid var(--orange);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);

    &:hover {
      background: var(--grayLv3);
      color: var(--white);
    }

  }
`;

interface ButtonSubmitProps extends ButtonProps {
  children: React.ReactNode;
}

export default function ButtonCancel({ children, ...rest }: ButtonSubmitProps) {
  return (
    <Button {...rest}>{children}</Button>
  )
}
